var exports = {
  "custom-switcher": "x43cbe9c2--48bdc1--custom-switcher",
  "custom-switcher-item": "x43cbe9c2--48bdc1--custom-switcher-item",
  "active": "x43cbe9c2--48bdc1--active",
  "coin": "x43cbe9c2--48bdc1--coin",
  "calendar": "x43cbe9c2--48bdc1--calendar",
  "key": "x43cbe9c2--48bdc1--key",
  "container": "x43cbe9c2--48bdc1--container",
  "tablet": "x43cbe9c2--48bdc1--tablet",
  "phone": "x43cbe9c2--48bdc1--phone",
  "switchers-body": "x43cbe9c2--48bdc1--switchers-body",
  "switch": "x43cbe9c2--48bdc1--switch",
  "switcher-title": "x43cbe9c2--48bdc1--switcher-title",
  "image": "x43cbe9c2--48bdc1--image",
  "text": "x43cbe9c2--48bdc1--text",
  "btn-container": "x43cbe9c2--48bdc1--btn-container",
};

module.exports = exports;
